export const ui_en = {
  'loading-spinner': {
    'initial-message': {
      title: 'Hang tight!',
      description: 'This may take a few more minutes to process your request.',
    },
  },
  modal: {
    title: {
      type: {
        error: 'Error',
        success: 'Success',
        alert: 'Alert',
        warning: 'Warning',
      },
    },
    button: {
      cancel: 'Cancel',
      confirm: 'Confirm',
    },
  },
};
